import { UserDataState } from './UserDataState';

const UPPER_GI_VALUES_EXCLUDED_FROM_SYMPTOMS = new Set(['None', 'More/Other']);

/** Derive the legacy report field while keeping each split symptom screen independent. */
export function prepareUserDataForPersistence(userData: UserDataState): UserDataState {
  if (userData.lowerGISymptoms === undefined) return userData;

  const upperGISymptoms = (userData.upperGISymptoms ?? []).filter(
    (symptom) => !UPPER_GI_VALUES_EXCLUDED_FROM_SYMPTOMS.has(symptom)
  );

  return {
    ...userData,
    symptoms: [...new Set([...userData.lowerGISymptoms, ...upperGISymptoms])],
  };
}
